import React from 'react';
import styled from 'styled-components';
import FeatureSectionCard from 'components/ForCreatorSections/FeatureSectionCard';

import Text, { TypeVariant } from 'shared/Typography';
import { Title, TitleRow, Section } from '../Marketing/marketing.styles';
import Spacer, { Size } from 'shared/Spacer';

interface FeaturesData {
  label: string;
  value: string;
}

const data: FeaturesData[] = [
  {
    label: 'Expansive Content Options',
    value:
      'Sell single sessions, community challenges, full length programs and more',
  },
  {
    label: 'Drop in Live Classes',
    value: 'Enable your community to drop in to your class at any time',
  },
  {
    label: 'One Time Paid Events',
    value:
      'Create buzz by hosting a special event on your own or with partners',
  },
  {
    label: 'Marketing and Promo Codes',
    value:
      'Drive increased conversion to your paid offering with special deals',
  },
  {
    label: 'Analytics',
    value: 'Understand how users are engaging with you and your content',
  },
  {
    label: 'Software Integrations',
    value:
      'Software integrations that make it easier for you to run your online community',
  },
];

const RowSectionThree = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding: 0 20px;
  } ;
`;

const ContainerSecThree = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SectionSix = () => (
  <Section>
    <Spacer size={Size.spacing64} />
    <ContainerSecThree>
      <RowSectionThree style={{ maxWidth: '1100px', width: '100%' }}>
        <Title>
          <TitleRow>
            <Text
              variant={TypeVariant.header02}
              as="h2"
              tablet={TypeVariant.subtitle01}
              textAlign="center"
            >
              Features to Grow Your Audience
            </Text>
          </TitleRow>
        </Title>
        {data.map((val, i) => (
          <FeatureSectionCard
            key={i}
            label={val.label}
            value={val.value}
            bgColor="#101B3B"
            bgHover="black"
            perRow={3}
          />
        ))}
      </RowSectionThree>
    </ContainerSecThree>
  </Section>
);

export default SectionSix;
